<template>
  
  <v-flex xs12 sm12 md12 class="mt-3">
    <v-card>
      <v-card-text class="mt-0">

        <BoxHeader 
          :questionObj="question" 
          title="Upload photo">
        </BoxHeader>

        <!-- Question -->
        <v-textarea 
          :counter="250"
          label="Write question here"
          v-model="questionText"
          v-on:input="setTextForQuestionObj($event)" 
          :rules="[rules.required]"
          auto-grow
          autofocus
        ></v-textarea>
      
        <v-btn 
          block 
          :loading="loading"
          :disabled="true"
          color="blue-grey"
          class="white--text"
          @click.native="openFileDialog"
        >
          Upload
          <v-icon right dark> cloud_upload</v-icon>
        </v-btn>
       <input type="file" id="file-upload" style="display:none" @change="onFileChange">
        <p class="text-xs-right"><i>*Above is an example button.</i></p>
      </v-card-text>

    </v-card>
  </v-flex>

</template>

<script>
// @ is an alias to /src
import BoxHeader from '@/components/questionForms/BoxHeader.vue'

export default {
  name: "photobox",
  components: {
    BoxHeader
  },
  props: {
    question: Object
  },
  data: () => ({
    questionText: null,
    formData: new FormData(),
    pickedTime : null,
    loading: false,
    rules: {
      required: value => !!value || 'Cannot Be Empty.'
    }
  }),
  computed: {
  },
  created() {
    this.questionText = this.question.text;
  },
  methods: {

    setTextForQuestionObj(text) {
      this.$store.commit('setTextForQuestionObj', {questionObj: this.question, text:text});
    },
    
    openFileDialog() {
      document.getElementById('file-upload').click();
    },
    onFileChange(e) {
      this.loading = true;

      var files = e.target.files || e.dataTransfer.files;       
      if(files.length > 0){
        for(var i = 0; i< files.length; i++){
          this.formData.append("file", files[i], files[i].name);
          console.log(files[i].name);
        }
      } 
    },
    uploadFile() {
      var self = this; 
      // axios.post('URL', self.formData).then(function (response) {
      //   console.log(response);
      // }).catch(function (error) {
      //   console.log(error);
      // });
    }
  }
};
</script>

<style scoped>

</style>